export default __webpack_public_path__ + "static/media/pot1.20e0dd4c.jpg";